export class CommandHistory {
    private history: string[] = [];
    private currentIndex: number = -1;

    constructor(history: string[]) {
        this.history = history;
        this.currentIndex = this.history.length || -1;
    }

    addToHistory(command: string): void {
        this.history.push(command);
        this.currentIndex = this.history.length;
    }

    getPreviousCommand(): string | null {
        if (this.currentIndex > 0) {
            this.currentIndex--;
            return this.history[this.currentIndex];
        }
        return this.history[this.currentIndex] || null;
    }

    getNextCommand(): string | null {
        if (this.currentIndex < this.history.length - 1) {
            this.currentIndex++;
            return this.history[this.currentIndex];
        }
        return null;
    }
}
